export default __webpack_public_path__ + "static/media/set-normal-5.3caad80a.png";